<template>
    <el-card :class="getLoadingClass">
        <div v-if="IsDisplayOverview" :style="{ marginBottom: '1rem' }">
          <el-row type="flex" :gutter="32" :style="{ flexWrap: 'wrap' }">
            <el-col :sm="8" :md="6">
              <AppTracker
                label="รายรับ"
                :value="getIncome"
                unit="บาท"
              />
            </el-col>
            <el-col :sm="8" :md="6">
              <AppTracker
                label="รายจ่าย"
                :value="getExpense"
                unit="บาท"
              />
            </el-col>
          </el-row>
        </div>

        <el-table 
          :data="this.items"
          :headerCellClassName="getTableClass"
          :cellClassName="getTableClass">

            <el-table-column label="วันที่" minWidth="150" #default="row">
               {{ displayDate(row) }} 
            </el-table-column>
            <el-table-column label="ชนิด" minWidth="100" #default="row">
              {{ displayType(row) }} 
            </el-table-column>
            <el-table-column label="รายละเอียด" minWidth="250" prop="description" />
            <el-table-column label="รายรับ" minWidth="130" align="right" #default="row">
              <span :class="getGreenClass" :style="{ fontWeight: 'bold' }"> 
                  {{ displayAmount(row,true)}}
              </span>
            </el-table-column>  
            <el-table-column label="รายจ่าย"  minWidth="130" align="right" #default="row">
              <span :class="getRedClass" :style="{ fontWeight: 'bold' }"> 
                {{ displayAmount(row,false)}}
              </span>
            </el-table-column>  
            <el-table-column width="150" #default="row">
              <el-button size="medium" @click="detailClick(row)">
                    See Detail <i class="el-icon-arrow-right"></i>
              </el-button>
            </el-table-column>      
        </el-table>
        <div
           :style="{
            display: 'flex',
            marginTop: '1rem',
            overflow: 'auto hidden'
          }">
          <el-pagination
            background
            :currentPage="this.pagination.page"
            :total="this.pagination.total"
            :pageSize="this.pagination.pageSize"
            layout="prev, pager, next, jumper"
            :style="{ margin: 'auto' }"

            @update:current-page="currentPage"
            @current-change="changePage"
          />
        </div>
      </el-card>
</template>

<script>
import moment from 'moment'
import numeral from 'numeral'
import snakeCase from 'lodash-es/snakeCase'
import elementUiStyles from '@/assets/scss/modules/element-ui.module.scss'
import utilStyles from '@/assets/scss/modules/utilities.module.scss'
import { AppTracker } from '@/components/ui/tracker'
import { IncomeExpenseService } from '@/services'
import { toThaiDatetime } from '@/utils/datetime'

export default {
  components: {
    AppTracker
  },
  data() {
    const { query } = this.$route

    return {
      overview: {
        income: 0,
        expense: 0
      },
      items: [],
      pagination: {
        page: parseInt(query.page) || 1,
        total: 100,
        pageSize: 10
      },
      isLoading: false
    }
  },
  created() {
    this.fetch()
    if (this.$route.query.start && this.$route.query.end) {
       this.fetchOverview()
    }
  },
  computed: {
    IsDisplayOverview() {
        return this.$route.query.start && this.$route.query.end;
    },
    getGreenClass() {
        return utilStyles.colorSuccess;
    },
    getRedClass() {
        return utilStyles.colorDanger;
    },
    getLoadingClass() {
      return this.isLoading? this.$style.loading : false ;
    },
    getTableClass() {
      return elementUiStyles.tableCell;
    },
    getIncome() {
      return this.overview.income
    },
    getExpense() {
      return this.overview.expense
    }
  },
  methods: {
    displayDate(obj) {
       return toThaiDatetime(obj.row.transdate);
    },
    displayType(obj) {
       const transType = obj.row.type;
       
       return transType? transType.replace("จำนำ","ขายฝาก"):"";
    },
    displayAmount(obj,isReceive) {
      const amount =obj.row.amount;
      let result = "";

      if (isReceive) {
         result = amount >= 0? numeral(amount).format('0,0.00'):""
      } else {
         result = amount < 0? numeral(amount).format('0,0.00'):""
      }
      return result;
    },
    detailClick(obj) {
        this.$router.push(obj.row.to)
    },
    currentPage(value) {
        this.pagination.page = value
    },
    async changePage(value) {
        await this.$router.replace({
          query: { ...this.$route.query, page: value }
        })

        this.fetch()
    },
    async fetch() {
      const query = this.$route.query

      this.isLoading = true

      try {
        const {
          data: { status, result }
        } = await IncomeExpenseService.getAll({
          income_expense_type__id: query.type,
          datetime_after: query.start
            ? moment(query.start).format()
            : undefined,
          datetime_before: query.end ? moment(query.end).format() : undefined,
          page: query.page
        })

        if (status === 'error')
          throw new Error('เกิดข้อผิดพลาดในการรับข้อมูลรายรับ รายจ่าย')

        this.items = result.results.map(item => {
          const getDetail = () => {
            if (item.ref_content_type) {
              const type = { receipt: 'sell', buyreceipt: 'buy' }[
                item.ref_content_type.model
              ]

              if (item.income_expense_type) {
                switch (snakeCase(item.income_expense_type.name)) {
                  case 'trade':
                    return {
                      type: 'แลกเปลี่ยน',
                      to: {
                        name: 'TradeDetail',
                        params: { type, id: item.ref_id }
                      }
                    }

                  case 'pawn':
                  case 'pawn_extend':
                  case 'pawn_redeem':
                    return {
                      type: item.income_expense_type.name_locale,
                      to: {
                        name: 'PawnDetail',
                        params: { id: item.ref_id }
                      }
                    }
                }
              }

              switch (type) {
                case 'sell':
                  return {
                    type: 'ขายออก',
                    to: { name: 'SellDetail', params: { id: item.ref_id } }
                  }

                case 'buy':
                  return {
                    type: 'รับซื้อ',
                    to: { name: 'BuyDetail', params: { id: item.ref_id } }
                  }
              }
            }

            if (item.income_expense_type) {
              switch (snakeCase(item.income_expense_type.name)) {
                case 'transfer_inbound':
                  return {
                    type: item.income_expense_type.name_locale,
                    to: {
                      name: 'CashTransferHistoryDetail',
                      params: { type: 'receive', id: item.ref_id }
                    }
                  }

                case 'transfer_outbound':
                  return {
                    type: item.income_expense_type.name_locale,
                    to: {
                      name: 'CashTransferHistoryDetail',
                      params: { type: 'transfer', id: item.ref_id }
                    }
                  }

                default:
                  return {
                    type: item.income_expense_type.name_locale,
                    to: {
                      name: item.is_expense
                        ? 'IncomeExpenseExpenseDetail'
                        : 'IncomeExpenseIncomeDetail',
                      params: { id: item.id }
                    }
                  }
              }
            }
          }

          const detail = getDetail()

          return {
            id: item.id,
            transdate: new Date(item.datetime),
            type: detail ? detail.type : null,
            description: item.description,
            amount: +item.total,
            to: detail ? detail.to : null
          }
        })

        this.pagination = { ...this.pagination, total: result.count }
      } catch (err) {
        this.$notify.error(err.message)
      } finally {
        this.isLoading = false
      }
    },

    async fetchOverview() {
      const query = this.$route.query

      try {
        const {
          data: { status, result }
        } = await IncomeExpenseService.getOverview({
          datetime_after: moment(query.start).format(),
          datetime_before: moment(query.end).format()
        })

        if (status === 'error')
          throw new Error('เกิดข้อผิดพลาดในการรับข้อมูลภาพรวม')

        this.overview = {
            income: parseFloat(result.income),
            expense: parseFloat(result.expense)
        }

      } catch (err) {
        this.$notify.error(err.message)
      }
    },

    reset() {
        this.pagination.page = 1
    }
  },
  /*
  render() {
    const Overview = () => (
      <div style={{ marginBottom: '1rem' }}>
        <el-row type="flex" gutter={32} style={{ flexWrap: 'wrap' }}>
          <el-col sm={8} md={6}>
            <AppTracker
              label="รายรับ"
              value={this.overview.income}
              unit="บาท"
            />
          </el-col>
          <el-col sm={8} md={6}>
            <AppTracker
              label="รายจ่าย"
              value={this.overview.expense}
              unit="บาท"
            />
          </el-col>
        </el-row>
      </div>
    )

    const DetailButton = ({ props }) => {
      const handleClick = () => {
        this.$router.push(props.to)
      }

      return (
        <el-button size="medium" onClick={handleClick}>
          See Detail <i class="el-icon-arrow-right"></i>
        </el-button>
      )
    }

    return (
      <el-card
        element-loading-background="rgba(0, 0, 0, 0.75)"
        element-loading-custom-class={elementUiStyles.loadingMask}
        {...{ directives: [{ name: 'loading', value: this.isLoading }] }}
      >
        {this.$route.query.start && this.$route.query.end && <Overview />}
        <el-table
          data={this.items}
          headerCellClassName={elementUiStyles.tableCell}
          cellClassName={elementUiStyles.tableCell}
        >
          <el-table-column
            label="วันที่"
            minWidth="150"
            scopedSlots={{ default: ({ row }) => toThaiDatetime(row.date) }}
          />
          <el-table-column
            label="ชนิด"
            minWidth="100"
            scopedSlots={{ default: ({ row }) => row.type }}
          />
          <el-table-column
            label="รายละเอียด"
            prop="description"
            minWidth="250"
          />
          <el-table-column
            label="รายรับ"
            align="right"
            minWidth="130"
            scopedSlots={{
              default: ({ row }) =>
                row.amount >= 0 ? (
                  <span
                    class={
                      row.amount > 0
                        ? utilStyles.colorSuccess
                        : utilStyles.textSecondary
                    }
                    style={{ fontWeight: 'bold' }}
                  >
                    {numeral(row.amount).format('0,0.00')}
                  </span>
                ) : (
                  undefined
                )
            }}
          />
          <el-table-column
            label="รายจ่ายxx"
            align="right"
            minWidth="130"
            scopedSlots={{
              default: ({ row }) =>
                row.amount < 0 ? (
                  <span
                    class={utilStyles.colorDanger}
                    style={{ fontWeight: 'bold' }}
                  >
                    {numeral(row.amount).format('0,0.00')}
                  </span>
                ) : (
                  undefined
                )
            }}
          />
          <el-table-column
            width="150"
            scopedSlots={{
              default: ({ row }) => row.to && <DetailButton to={row.to} />
            }}
          />
        </el-table>
        <div
          style={{
            display: 'flex',
            marginTop: '1rem',
            overflow: 'auto hidden'
          }}
        >
          <el-pagination
            background
            currentPage={this.pagination.page}
            total={this.pagination.total}
            pageSize={this.pagination.pageSize}
            layout="prev, pager, next, jumper"
            style={{ margin: 'auto' }}
            on={{
              'update:currentPage': value => {
                this.pagination.page = value
              },
              'current-change': async value => {
                await this.$router.replace({
                  query: { ...this.$route.query, page: value }
                })

                this.fetch()
              }
            }}
          />
        </div>
      </el-card>
    )
  } */
}
</script>

<style scoped lang="scss" module>
.loading {
   background-color:rgba(0, 0, 0, 0.75);
}

</style>